module.exports = __webpack_public_path__ + "static/media/hicloudy.ff77ca91.svg";